import { scenarioListWidget, scenarioWidgetExtraList } from "../../api";
import Cookies from "js-cookie";
import { useState } from "react";
import { Alert } from "../Alert";
import { ModalComp } from "../ModalComp";
import { AutomationEdit } from "./AutomationEdit";

const AutommationsModal = ({ automation, closeModal }) => {
  const { title, icon, uid } = automation;

  const token = Cookies.get("token");
  const [openAddScenarioModal, setOpenAddScenarioModal] = useState(false);
  const [openAddAutomationModal, setOpenAddAutomationModal] = useState(false);
  const [submitScenarioEdit, setSubmitScenarioEdit] = useState(false);
  const [rfsh, setRfsh] = useState(false);
  const toggleAddAutomation = () => {
    setOpenAddAutomationModal(!openAddAutomationModal);
    setSubmitScenarioEdit(!submitScenarioEdit);
  };

  const [scenarioCommand, setScenarioCommand] = useState([]);
  const [widgetIndex, setWidgetIndex] = useState("");

  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
    }));
  };
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
    question: false,
    request: "",
  });

  //deleteAutomation//
  const handleDeleteAutomation = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: true,
      message: `آیا از حذف اتوماسیون ${title} اطمینان دارید؟`,
      type: "Warning",
      question: true,
      request: "DeleteAutomation",
    }));
  };

  return (
    <>
      <ModalComp
        modal={openAddAutomationModal}
        toggle={toggleAddAutomation}
        component={
          <AutomationEdit
            titleEdit={title}
            iconEdit={icon}
            uid={uid}
            setOpenAddAutomationModal={setOpenAddAutomationModal}
            closeModal={closeModal}
          />
        }
      />
      <div className="bg-gray" style={{ minHeight: "80vh" }}>
        <div className="d-flex align-items-center flex-column">
          <i className="circleTop  text-center">
            <i className={`${icon} d-block`}></i>
          </i>
          <div className="text-center mt-2">
            <p className="m-0">اتوماسیون</p>
            <p className="fn12 ">{title}</p>
          </div>
        </div>

        <div
          className="w-100 text-right borderBottom mb-3 cursor"
          onClick={toggleAddAutomation}
        >
          <p className="fn">ویرایش</p>
        </div>
        <div
          className="w-100 text-right borderBottom mb-3 cursor"
          onClick={handleDeleteAutomation}
        >
          <p className="fn"> حذف</p>
        </div>

        {showAlert.show && (
          <Alert
            message={showAlert.message}
            type={showAlert.type}
            question={showAlert.question}
            id={uid}
            toggleAlert={toggleAlert}
            request={showAlert.request}
            closeModal={closeModal}
            setOpenAddAutomationModal={setOpenAddAutomationModal}
            toggleAddAutomation={toggleAddAutomation}
            title={title}
            icon={icon}
            uid={uid}
          />
        )}
      </div>
    </>
  );
};
export { AutommationsModal };
